
<div class="groups-page">

  <!-- CARICAMENTO INTERO COMPONENTE -->
  <div
    *ngIf="groupsLoading"
    class="groups-loading"
    role="status"
    aria-live="polite"
  >
    <img
      src="assets/icons/loading-spinner.svg"
      alt="Caricamento accessi e autorizzazioni"
      class="groups-loading-image"
    />

    <span>Caricamento accessi e autorizzazioni in corso...</span>
  </div>

  <ng-container *ngIf="!groupsLoading">

    <p-tabView styleClass="groups-tabview">

      <!-- ACCESSI -->
      <p-tabPanel header="Accessi">

        <section class="groups-section">

          <div class="groups-section-header">
            <div class="groups-section-heading">

              <div class="groups-section-icon">
                <i class="pi pi-users"></i>
              </div>

              <div class="groups-section-heading-text">
                <h2>Accessi utenti</h2>
                <p>
                  Gestisci le credenziali e controlla gli ultimi accessi.
                </p>
              </div>

            </div>
          </div>

          <div class="groups-section-body">

            <p-table
              #dt
              [value]="auths"
              dataKey="signId"
              editMode="row"
              styleClass="p-datatable-sm groups-access-table"
              [scrollable]="true"
              scrollHeight="flex"
              [globalFilterFields]="[
                'subscriber.name',
                'subscriber.lastName',
                'email'
              ]"
            >

              <ng-template pTemplate="caption">

                <div class="groups-table-toolbar">

                  <div class="groups-access-summary">

                    <div class="groups-summary-icon">
                      <i class="pi pi-user"></i>
                    </div>

                    <div class="groups-summary-text">
                      <strong>
                        {{ totals.enabled }} utenti abilitati
                      </strong>

                      <span>
                        su {{ totals.total }} utenti totali
                      </span>
                    </div>

                  </div>

                  <div class="groups-table-actions">

                    <span class="p-input-icon-left groups-search">
                      <i class="pi pi-search"></i>

                      <input
                        pInputText
                        type="text"
                        [(ngModel)]="search"
                        (ngModelChange)="dt.filterGlobal(search, 'contains')"
                        placeholder="Cerca utente..."
                      />
                    </span>

                    <p-button
                      label="Aggiorna"
                      icon="pi pi-refresh"
                      [outlined]="true"
                      (onClick)="loadUsers()"
                    ></p-button>

                  </div>

                </div>

              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th class="groups-actions-column">
                    Azioni
                  </th>

                  <th>Nome e cognome</th>

                  <th>Email</th>

                  <th
                    pSortableColumn="passwordExpirationDate"
                    (click)="expirationSortChanged()"
                  >
                    Scadenza password
                    <p-sortIcon
                      field="passwordExpirationDate"
                    ></p-sortIcon>
                  </th>

                  <th
                    pSortableColumn="latestLoginDate"
                    (click)="lastLoginSortChanged()"
                  >
                    Ultimo accesso
                    <p-sortIcon
                      field="latestLoginDate"
                    ></p-sortIcon>
                  </th>
                </tr>
              </ng-template>

              <ng-template
                pTemplate="body"
                let-signIn
                let-editing="editing"
                let-ri="rowIndex"
              >

                <tr [pEditableRow]="signIn">

                  <td>
                    <div class="groups-row-actions">

                      <p-overlayPanel #overlay>

                        <div class="groups-overlay-actions">

                          <button
                            *ngIf="
                              !editing &&
                              signIn.signId !== undefined
                            "
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-text p-button-danger"
                            (click)="removeSignIn(signIn)"
                            pTooltip="Rimuovi"
                            tooltipPosition="top"
                          ></button>

                          <button
                            *ngIf="
                              !editing &&
                              signIn.signId !== undefined
                            "
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-history"
                            class="p-button-rounded p-button-text"
                            (click)="viewUserHistory(signIn)"
                            pTooltip="Cronologia accessi"
                            tooltipPosition="top"
                          ></button>

                          <button
                            *ngIf="signIn.signId !== undefined"
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-ban"
                            class="p-button-rounded p-button-text"
                            (click)="resetPasswordExpiration(signIn)"
                            pTooltip="Scadenza password"
                            tooltipPosition="top"
                          ></button>

                          <button
                            *ngIf="signIn.signId !== undefined"
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-refresh"
                            class="p-button-rounded p-button-text"
                            (click)="resetPassword(signIn)"
                            pTooltip="Reset password"
                            tooltipPosition="top"
                          ></button>

                        </div>
                      </p-overlayPanel>

                      <button
                        *ngIf="signIn.signId === undefined"
                        pButton
                        pRipple
                        type="button"
                        icon="pi pi-tag"
                        class="p-button-rounded p-button-text"
                        (click)="confirmCreate(signIn)"
                        pTooltip="Abilita accesso"
                        tooltipPosition="top"
                      ></button>

                      <button
                        *ngIf="
                          !editing &&
                          signIn.signId !== undefined
                        "
                        pButton
                        pRipple
                        type="button"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-text"
                        (click)="onRowEditInit(signIn)"
                        pTooltip="Modifica"
                        tooltipPosition="top"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        type="button"
                        pSaveEditableRow
                        icon="pi pi-check"
                        class="p-button-rounded p-button-text p-button-success"
                        (click)="onRowEditSave(signIn)"
                        pTooltip="Salva"
                        tooltipPosition="top"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        type="button"
                        pCancelEditableRow
                        icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-danger"
                        (click)="onRowEditCancel(signIn, ri)"
                        pTooltip="Annulla"
                        tooltipPosition="top"
                      ></button>

                      <button
                        *ngIf="signIn.signId !== undefined"
                        pButton
                        pRipple
                        type="button"
                        icon="pi pi-ellipsis-v"
                        class="p-button-rounded p-button-text"
                        [disabled]="editing"
                        (click)="overlay.toggle($event)"
                        pTooltip="Altre azioni"
                        tooltipPosition="top"
                      ></button>

                    </div>
                  </td>

                  <td>
                    <span class="groups-user-name">
                      {{ signIn.subscriber.name }}
                      {{ signIn.subscriber.lastName }}
                    </span>
                  </td>

                  <td>
                    <p-cellEditor>

                      <ng-template pTemplate="input">
                        <input
                          pInputText
                          type="text"
                          [(ngModel)]="signIn.email"
                          class="groups-table-edit-input"
                        />
                      </ng-template>

                      <ng-template pTemplate="output">
                        <span class="groups-user-email">
                          {{ signIn.email | slice:0:50 }}

                          <span *ngIf="signIn.email.length > 50">
                            ...
                          </span>
                        </span>
                      </ng-template>

                    </p-cellEditor>
                  </td>

                  <td>
                    <span
                      *ngIf="signIn.signId !== undefined"
                      class="groups-date"
                    >
                      {{ signIn.passwordExpirationDate | date:'dd/MM/y' }}
                    </span>

                    <span
                      *ngIf="signIn.signId === undefined"
                      class="groups-muted"
                    >
                      Non abilitato
                    </span>
                  </td>

                  <td>
                    <span
                      *ngIf="signIn.latestLoginDate !== undefined"
                      class="groups-date"
                    >
                      {{ signIn.latestLoginDate | date:'dd/MM/y H:mm' }}
                    </span>

                    <span
                      *ngIf="signIn.latestLoginDate === undefined"
                      class="groups-muted"
                    >
                      Nessun accesso
                    </span>
                  </td>

                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">
                    <div class="groups-empty-state">
                      <i class="pi pi-users"></i>

                      <strong>
                        Nessun utente trovato
                      </strong>

                      <span>
                        Prova a modificare i criteri di ricerca.
                      </span>
                    </div>
                  </td>
                </tr>
              </ng-template>

            </p-table>

          </div>
        </section>

      </p-tabPanel>

      <!-- AUTORIZZAZIONI -->
      <p-tabPanel header="Autorizzazioni">

        <section class="groups-section">

          <div class="groups-section-header">

            <div class="groups-section-heading">

              <div class="groups-section-icon">
                <i class="pi pi-shield"></i>
              </div>

              <div class="groups-section-heading-text">
                <h2>Gruppi di autorizzazione</h2>

                <p>
                  Configura i gruppi, le autorizzazioni
                  e gli utenti associati.
                </p>
              </div>

            </div>

            <div class="groups-header-actions">

              <span class="groups-count-badge">
                {{ groups.length }} gruppi
              </span>

              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-plus"
                label="Nuovo gruppo"
                class="groups-new-button"
                (click)="addNewGroup()"
              ></button>

            </div>

          </div>

          <div class="groups-section-body">

            <div class="groups-cards-grid">

              <ng-container
                *ngFor="let group of groups; index as index"
              >

                <article class="authorization-card">

                  <div class="authorization-card-header">

                    <div class="authorization-card-title-row">

                      <div class="authorization-card-icon">
                        <i class="pi pi-users"></i>
                      </div>

                      <div class="authorization-card-title">

                        <h3
                          *ngIf="
                            group.groupId !== selectedGroup?.groupId
                          "
                        >
                          {{ group.description }}
                        </h3>

                        <input
                          *ngIf="
                            group.groupId === selectedGroup?.groupId
                          "
                          pInputText
                          type="text"
                          [(ngModel)]="group.description"
                          placeholder="Descrizione gruppo"
                          class="groups-edit-input"
                        />

                      </div>

                    </div>

                    <div class="authorization-card-meta">

                      <ng-container
                        *ngIf="
                          group.groupId !== selectedGroup?.groupId
                        "
                      >
                        <span class="authorization-group-name">
                          {{ group.name }}
                        </span>
                      </ng-container>

                      <input
                        *ngIf="
                          group.groupId === selectedGroup?.groupId
                        "
                        pInputText
                        type="text"
                        [(ngModel)]="group.name"
                        placeholder="Nome gruppo"
                        class="groups-edit-input"
                      />

                      <span class="authorization-group-id">
                        ID: {{ group.groupId }}
                      </span>

                    </div>

                  </div>

                  <div class="authorization-card-body">

                    <div class="authorization-expiration">

                      <div class="authorization-expiration-icon">
                        <i class="pi pi-clock"></i>
                      </div>

                      <div class="authorization-expiration-text">

                        <span>Scadenza password</span>

                        <strong
                          *ngIf="
                            group.groupId !== selectedGroup?.groupId
                          "
                        >
                          {{ group.passwordExpirationInDays }} giorni
                        </strong>

                        <div
                          *ngIf="
                            group.groupId === selectedGroup?.groupId
                          "
                          class="authorization-expiration-edit"
                        >
                          <input
                            pInputText
                            type="number"
                            min="1"
                            [(ngModel)]="group.passwordExpirationInDays"
                            class="groups-edit-input"
                          />
                        </div>

                      </div>
                    </div>

                    <div class="authorization-status-row">

                      <span class="authorization-status-label">
                        Stato gruppo
                      </span>

                      <p-toggleButton
                        [(ngModel)]="group.isEnabled"
                        onLabel="Abilitato"
                        offLabel="Disabilitato"
                        [disabled]="
                          group.groupId !== selectedGroup?.groupId
                        "
                      ></p-toggleButton>

                    </div>

                    <div class="authorization-quick-actions">

                      <p-button
                        label="Permessi"
                        icon="pi pi-external-link"
                        [disabled]="
                          group.groupId !== selectedGroup?.groupId &&
                          selectedGroup?.groupId !== undefined
                        "
                        (onClick)="showAuthorizations(index)"
                      ></p-button>

                      <p-button
                        label="Utenti"
                        icon="pi pi-users"
                        [disabled]="
                          group.groupId !== selectedGroup?.groupId &&
                          selectedGroup?.groupId !== undefined
                        "
                        (onClick)="modifyAuthorizedUsers()"
                      ></p-button>

                    </div>

                  </div>

                  <div class="authorization-card-footer">

                    <ng-container
                      *ngIf="
                        group.groupId !== selectedGroup?.groupId
                      "
                    >
                      <p-button
                        label="Modifica"
                        icon="pi pi-pencil"
                        severity="secondary"
                        (onClick)="editGroup(group)"
                      ></p-button>

                      <p-button
                        label="Elimina"
                        icon="pi pi-times"
                        severity="danger"
                        (onClick)="removeGroup(group, index)"
                      ></p-button>
                    </ng-container>

                    <ng-container
                      *ngIf="
                        group.groupId === selectedGroup?.groupId
                      "
                    >
                      <p-button
                        label="Salva"
                        icon="pi pi-save"
                        severity="success"
                        (onClick)="modifyGroup(index)"
                      ></p-button>

                      <p-button
                        label="Annulla"
                        icon="pi pi-times"
                        severity="danger"
                        (onClick)="cancel(index)"
                      ></p-button>
                    </ng-container>

                  </div>

                </article>

              </ng-container>

            </div>

            <div
              *ngIf="groups.length === 0"
              class="groups-empty-state"
            >
              <i class="pi pi-shield"></i>

              <strong>
                Nessun gruppo disponibile
              </strong>

              <span>
                Utilizza il pulsante Nuovo gruppo
                per aggiungere un'autorizzazione.
              </span>
            </div>

          </div>

        </section>

      </p-tabPanel>

    </p-tabView>

  </ng-container>

</div>

<!-- DIALOG CREAZIONE NUOVO GRUPPO -->
<p-dialog
  header="Nuovo gruppo"
  [(visible)]="newGroupDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!newGroupSaving"
  [closeOnEscape]="!newGroupSaving"
  [dismissableMask]="false"
  [style]="{ width: '460px', maxWidth: 'calc(100vw - 24px)' }"
  styleClass="groups-new-dialog"
  (onHide)="cancelNewGroup()"
>
  <form class="groups-new-form" (ngSubmit)="saveNewGroup()" #newGroupForm="ngForm">
    <div class="groups-new-field">
      <label for="new-group-description">Descrizione *</label>
      <input
        id="new-group-description"
        name="newGroupDescription"
        pInputText
        type="text"
        [(ngModel)]="newGroup.description"
        [disabled]="newGroupSaving"
        placeholder="Descrizione del gruppo"
        maxlength="150"
        required
      />
    </div>

    <div class="groups-new-field">
      <label for="new-group-name">Nome gruppo *</label>
      <input
        id="new-group-name"
        name="newGroupName"
        pInputText
        type="text"
        [(ngModel)]="newGroup.name"
        [disabled]="newGroupSaving"
        placeholder="Nome del gruppo"
        maxlength="100"
        required
      />
    </div>

    <div class="groups-new-field">
      <label for="new-group-expiration">Scadenza password (giorni) *</label>
      <input
        id="new-group-expiration"
        name="newGroupExpiration"
        pInputText
        type="number"
        min="1"
        step="1"
        [(ngModel)]="newGroup.passwordExpirationInDays"
        [disabled]="newGroupSaving"
        required
      />
    </div>

    <div class="groups-new-status">
      <label for="new-group-status">Stato</label>
      <p-toggleButton
        inputId="new-group-status"
        name="newGroupStatus"
        [(ngModel)]="newGroup.isEnabled"
        onLabel="Abilitato"
        offLabel="Disabilitato"
        [disabled]="newGroupSaving"
      ></p-toggleButton>
    </div>

    <div class="groups-new-actions">
      <button
        pButton
        pRipple
        type="submit"
        icon="pi pi-check"
        label="Crea"
        [disabled]="!newGroupValid || newGroupForm.invalid || newGroupSaving"
        [loading]="newGroupSaving"
      ></button>
    </div>
  </form>
</p-dialog>

<!-- PULSANTE FLOTTANTE -->
<div
  *ngIf="
    !groupsLoading &&
    !functionalityDialogOpen &&
    !newGroupDialogVisible
  "
  class="groups-floating-menu"
>
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-tags"
    class="groups-floating-button"
    (click)="showAuthorizations(-1)"
    pTooltip="Gestione funzionalità"
    tooltipPosition="left"
    aria-label="Apri gestione funzionalità"
  ></button>
</div>
